<template>
  <div class=" w-full text-center  grid grid-cols-3">
    <!-- lock button -->
    <div @click="choseMarkt()"
         title="Seite Speeren"
         class="hover:bg-trader-blue hover:text-white p-1"
         :data-ui="'lock-page-'+page.pagePosition+''">

      <i v-if="page.lock" class="fa-solid fa-lock text-red-400"
         :class="[page.lock ? '' : 'text-black']"></i>
      <i v-else class="fa-solid fa-lock-open text-green-500"> </i>
    </div>
    <!-- page position -->
    <div class="p-1">
      <span>{{ page.pagePosition }}</span>
    </div>
    <!-- delete button -->
    <div @click="deleteTrue()" class="hover:bg-trader-blue hover:text-white p-1"
         title="Seite Löschen"
         :data-ui="'delete-page-'+ page.pagePosition+ ''">

      <i class="fa-solid fa-trash  hover:text-white"></i>
    </div>
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import SignalBus from "@/application/SignalBus";
import ChangePageLock from "@/components/Dialogs/ChangePageLock.vue";

export default {
  name: "CDeletePage",
  props: {
    pageId: {
      type: Number,
      required: true
    },
    page: {
      type: Object,
      required: true
    },
    markt: {
      type: Array,
      required: true
    },
    showMarkt: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    deleteTrue(id, type) {
      SignalBus.emit("Headline-Seite");
      eventBus.openConfirm({
        title: "Seite Löschen",
        message: "Möchten Sie diese Seite wirklich löschen?",
        type: "page",
        onAccept: () => {
          this.deletePage();
        },
      });
    },

    choseMarkt() {
      
      if (!this.showMarkt) {
        this.lockTruePage([],[]);
      }else {
        eventBus.openModal(ChangePageLock);
        eventBus.setData({
          markets: this.markt,
          page: this.page,
          onAccept: (marktIds, pageId ) => {
            this.lockTruePage(marktIds, pageId)
          },
        });
      }
    },
    async lockTruePage(marktIds, pageId) {
      const mutation = gql`
        mutation changePageLock($pageID: Int!, $marktIds: [Int!]!, $lock: Boolean!) {
          changePageLock(pageID: $pageID, marktIds: $marktIds, lock: $lock) {
            success
          }
        }
      `;
      try {
        const variables = {
          pageID: this.pageId,
          marktIds: marktIds,
          lock: this.page.lock
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        SignalBus.emit("reloadPages");

        await this.getPages()
      } catch (error) {
        console.error(error);
      }
    }
    ,
    async deletePage() {
      const mutation = gql`
        mutation deletePage($pageId: Int!) {
          deletePage(pageId: $pageId) {
            success
          }
        }
      `;

      try {
        const variables = {
          pageId: this.pageId
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        SignalBus.emit("reloadPages");
        if (data.deletePage.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Seite Gelöscht",
            message: "Diese Seite wurde Gelöscht.",
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    ,
  },
}
</script>